import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import email from '../../assets/email.svg';
import { useAuth0 } from '@auth0/auth0-react';
import Loader from '../../components/UI/Loader/Loader';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const EmailVerification = () => {
    const { isLoading, loginWithRedirect } = useAuth0();
    const [searchParams] = useSearchParams();
    const { content } = useContentfulContext();

    const [message, setMessage] = useState("");

    useEffect(() => {
        if (searchParams.get("message")) {
            setMessage(searchParams.get("message"))
        }
    }, [])

    const handleLogin = () => {
        loginWithRedirect({
          authorizationParams: {
            redirect_uri: process.env.REACT_APP_AUTH0_BASE_URL,
          },
        })
    }

    if (isLoading) return <Loader />;

    return (
        <section className='h-fit'>
            <div className="mx-auto flex flex-col md:flex-row items-center max-w-[75%] my-6">
                <div className="p-8 flex flex-col lg:w-1/2 justify-center items-start text-center m-auto my-9">
                    <div className="space-y-4 md:space-y-6 w-full">
                        <img src={email} alt="EMAIL" className='h-16' />
                        <h1 className="text-2xl font-bold leading-tight tracking-tight text-gray-900 md:text-3xl">
                            {content?.EMAIL_VERIFICATION_RESPONSE?.[message]?.message}
                        </h1>
                        <div className="flex-col items-center">
                            <p htmlFor="terms" className="font-light text-gray-500">
                                {content?.EMAIL_VERIFICATION_RESPONSE?.[message]?.description}
                            </p>
                        </div>
                        <button className="text-lg font-medium text-[#1038A5] hover:underline" onClick={handleLogin}>
                            {content?.EMAIL_VERIFICATION_CONTENT?.button?.login}
                        </button>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default EmailVerification;